// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-control/MissionControlStatus.jsx

import React from "react";
import { StatusChip } from "../../design-system/components";

function normalizeTone(tone) {
  if (tone === "low" || tone === "ok") return "success";
  if (tone === "medium" || tone === "warn") return "warning";
  if (tone === "high" || tone === "danger") return "danger";
  return "neutral";
}

export default function MissionControlStatus({
  children,
  tone = "neutral",
  dot = false,
}) {
  return (
    <StatusChip tone={normalizeTone(tone)} dot={dot}>
      {children}
    </StatusChip>
  );
}
